import React from 'react';
import { FC } from 'react';

export const LinkedLists: FC = () => {
    return (
        
        <div>
            <div> 
                <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vRSi6BeVQ23R3U_EaiXdtwu3HfGZi03wtbMEr-qWaqfk2G0yARq_dsPE1hf0_DOmg--Z7RLYXA54J7A/embed?start=false&loop=false&delayms=60000"
                 width="1200"
                 loading='lazy'
                 height="675">
        
                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};